import axios from 'axios'

export default {
  state: {
    webinars_list: null,
  },
  getters: {
    getWebinarsList: (s) => s.webinars_list,
  },
  mutations: {
    setWebinarsList: (s, list) =>
      (s.webinars_list = Array.isArray(list)
        ? list.filter((el) => el.translates.length)
        : list),
  },
  actions: {
    fetchWebinarsList(ctx, { lang = 'ru', type }) {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/webinars/items/?language=${lang}`,
      })
        .then((response) => {
          const list = response.data.results
          if (type) {
            ctx.commit(
              'setWebinarsList',
              list.filter((el) => el.type !== null && el.type.slug === type)
            )
          } else {
            ctx.commit(
              'setWebinarsList',
              list.filter((el) => el.type === null)
            )
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    WebinarsSetVideoProgress(ctx, { id, progress }) {
      const fd = new FormData()
      fd.append('progress', progress)
      return axios({
        method: 'POST',
        data: fd,
        url: `/api/v3/webinars/items/${id}/progress/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    WebinarsSetLike(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/webinars/items/${id}/like/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    WebinarsSetFavorite(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/webinars/items/${id}/favorite/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    WebinarsSetView(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/webinars/items/${id}/view/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    WebinarsMaterialSetLike(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/webinars/materials/${id}/like/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    WebinarsMaterialSetFavorite(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/webinars/materials/${id}/favorite/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    WebinarsLinkSetLike(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/webinars/links/${id}/like/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    WebinarsLinkSetFavorite(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/webinars/links/${id}/favorite/`,
      }).catch((error) => {
        console.error(error)
      })
    },
  },
}
